import UFOLabel from './UFOLabel';
export default UFOLabel;